export * from './userActions'

export const showLoader = () => {
  return { type: 'SHOW_BTN_LOADING' }
}

export const hideLoader = () => {
  return { type: 'HIDE_BTN_LOADING' }
}

export const showPageLoad = () => {
  return { type: 'SHOW_PAGE_LOADING' }
}

export const hidePageLoad = () => {
  return { type: 'HIDE_PAGE_LOADING' }
}
export const showProgressPageLoad = () => {
  return { type: 'SHOW_PROGRESS_PAGE_LOADING' }
}

export const hideProgressPageLoad = () => {
  return { type: 'HIDE_PROGRESS_PAGE_LOADING' }
}

export default {}
